import React, { useState, useEffect } from "react";
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import "../../css/seller/toko.css"
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import LoadingScreen from "../../components/LoadingScreen";
import provincess from '../../provinces';
import Alert from "../../components/Alert";

export default function SellerToko() {
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [userData, setUser] = React.useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [owner, setOwner] = useState(' ');
  const [shopName, setShopName] = useState(' ');
  const [image, setImage] = useState(' ');
  const [noHp, setNoHp] = useState(' ');
  const [description, setDescription] = useState(' ');
  const [provinc, setProvinc] = useState('Pilih');
  const [address, setAddress] = useState(' ');
  const [urlImg, setUrlImg] = React.useState('');
  const navigate = useNavigate();

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  useEffect(() => {
setUrlImg(userData.imgUrl)
  }, [userData.imgUrl]);

  const UploadButtons =
    <div className=" ms-auto me-auto d-block" style={{ width: 182, }}>
      <Stack direction="row" alignItems="center" spacing={2} style={{ display: "block", width: 210 }}>
        <Button variant="contained" component="label">
          Pilih Logo Toko <img alt="" src="/img/camera.png" className="ms-3" style={{ width: "30px" }}></img>
          <input hidden accept="image/*" multiple type="file" onChange={(e) => {
            setImage(e.target.files[0])
            setUrlImg(URL.createObjectURL(e.target.files[0]))
          }} />
        </Button>
      </Stack>
    </div>

  const uploadImage = async (image) => {
    setIsLoading(true)
    const url = 'https://w-shop-backend.vercel.app/api/images?type=PROFILE_IMG';
    const form = new FormData();
    form.append('image', image);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + cookies.accessToken,
      },
      body: form,
    })
    const body = await response.json();
    setUrlImg(body.data.imageUrl)
    setIsLoading(false)
    return body.data;
  }
  console.log(image);

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      let imageData = {}
      if (image !== ' ') {
        imageData = await uploadImage(image);
      } else {
        imageData = { imageUrl: userData.imgUrl, imageId: userData.imgId }
      }
      let shopNamee = (shopName !== ' ' ? shopName : userData.shopName)
      let ownerr = (owner !== ' ' ? owner : userData.owner)
      let phoneNumberr = (noHp !== ' ' ? noHp : userData.phoneNumber)
      let addresss = (address === ' ' ? userData.address : address)
      let provincess = (provinc !== 'Pilih' ? provinc : userData.provinces)
      console.log(provincess);
      let descriptionn = (description !== 'Pilih' ? description : userData.description)
      const data = {
        imgId: imageData.imageId,
        imgUrl: imageData.imageUrl,
        shopName: shopNamee,
        owner: ownerr,
        phoneNumber: phoneNumberr,
        provinces: provincess,
        address: addresss,
        description: descriptionn,
      };
      const url = 'https://w-shop-backend.vercel.app/api/sellers';
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + cookies.accessToken,
        },
        body: JSON.stringify(data),
      });
      const body = await response.json();
      if (body.status !== 'success') {
        throw new Error(body.message,);
      } else {
        const event = {
          type: 'alert',
          alert: {
            type: 'success',
            message: 'Update Ticket Data Success',
          }
        };
        setCookie('event', event, { path: '/' });
        setAlert(event.alert)
        activateAlert()
        setTimeout(() => {
          navigate(0)
        }, 100);
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: 'danger',
        message: 'Error: ' + error.message,
      })
      activateAlert();
    }
  }

  let tokoSeller = (<div className="toko m-5 ms-auto me-auto p-5">
    <Alert active={alertActive} type={alert.type} message={alert.message} />
    <LoadingScreen active={isLoading} />
    <h1 className="pToko">Profil Toko</h1>
    <hr />
    <div className="row">
      <div className="col-12 col-md-7 pe-4">
        <div className=" iTokoR mb-4">
          <h5 className="">{userData.email}</h5>
          <a href="/seller/updateEmail">Ubah</a>
        </div>
        <div className=" iTokoR mb-4">
          <h5 className="">Password</h5>
          <a href="/seller/updatePassword">Ubah</a>
        </div>
        <div className="iTokoR mb-4">
          <h5 className="">Nama Toko</h5>
          <input type="text" className="form-control" defaultValue={userData.shopName} onChange={(e) => {
            setShopName(e.target.value);
          }} />
        </div>
        <div className="iTokoR mb-4">
          <h5 className="">Owner</h5>
          <input type="text" className="form-control" defaultValue={userData.owner} onChange={(e) => {
            setOwner(e.target.value);
          }} />
        </div>
        <div className="iTokoR mb-4">
          <h5 className="">Nomor HP</h5>
          <input type="number" className="form-control" defaultValue={userData.phoneNumber} onChange={(e) => {
            setNoHp(e.target.value);
          }} />
        </div>
        <div className=" form-floating textA mb-5">
          <h5 className="">Deskripsi Toko</h5>
          <textarea className="form-control" style={{ height: "270px" }} defaultValue={userData.description} onChange={(e) => {
            setDescription(e.target.value);
          }}></textarea>
        </div>
      </div>
      <div className="col-12 col-md-5 border-start ">
        <h1 className='alamat'>Alamat</h1>
        <div className="mb-3">
          <label className="form-label">Provinsi</label>
          <select className="form-select" onChange={(e) => {
            setProvinc(e.target.value);
          }}>
            <option hidden>{userData.provinces}</option>
            {provincess.map((prov) => (
              <option key={prov.id} value={prov.name}>{prov.name}</option>
            ))
            }
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Jalan, rt/rw no, Kelurahan, Kecamatan, Kota</label>
          <input type="text" className="form-control" id="kecamatan" defaultValue={userData.address} onChange={(e) => {
            setAddress(e.target.value);
          }} />
        </div>
        <div className="iTokoR my-5 ">
          <img alt="" src={urlImg} style={{ borderRadius: "100px", width: "200px", height: "200px" }} className="ms-auto me-auto d-block mt-5 mb-4" />
          {UploadButtons}
        </div>
        <div className="iTokoR my-5 text-center">
          <label className='desga d-block mt-5'>Ukuran gambar : maks 1 mb</label>
          <label className='desga d-block mb-5'>Format gambar : JPG, PNG</label>
          <button type="submit" className="btn btn-primary bToko me-2  mt-4" onClick={handleUpdate}>Simpan</button>
          <button type="submit" className="btn btn-outline-primary bToko mt-4" onClick={() => { navigate('/shopPage/' + userData.id) }}>Preview</button>
        </div>
      </div>
    </div>
  </div >)

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={tokoSeller} titleAppBar={'Toko Saya'} />
    </div>
  );
}
